import Vue from 'vue';
import ToolBar from "../../parts/ToolBar.vue";
import { MUTATION_TYPES } from "../../../lib/mutationTypes";
export default Vue.extend({
    components: { ToolBar },
    name: "LessonBeginner",
    methods: {
        goKey() {
            this.$store.commit(MUTATION_TYPES.SET_BACK_PATH_FROM_KEY, '/lesson/beginner');
            this.$router.push('/lesson/key/caution');
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/lesson/LessonBeginner.vue
// module id = 640
// module chunks = 1